// components/products/ProductCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';
import utils from '../../utils';

function ProductCard({ product }) {
    const navigate = useNavigate();

    const handleViewProduct = () => {
        if (product?.slug) {
            navigate(`/product/${product.slug}`);
        }
    };

    const isPremium = product?.price > 4000;

    return (
        <div className="group relative flex flex-col overflow-hidden rounded-xl border dark:border-border-dark bg-white dark:bg-background-dark transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
            <div className="relative aspect-square overflow-hidden bg-gray-100 dark:bg-border-dark">
                <img
                    src={product?.image}
                    alt={product?.name}
                    onClick={handleViewProduct}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 cursor-pointer"
                />

                {isPremium && (
                    <span className="absolute top-3 left-3 bg-primary text-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider shadow-sm">
                        Premium
                    </span>
                )}
            </div>

            <div className="flex flex-1 flex-col p-5">
                {product?.product_type_name && (
                    <p className="text-[10px] uppercase tracking-widest text-gray-500 dark:text-gray-400 mb-1 font-bold">
                        { product.product_type_name ?? null}
                    </p>
                )}

                <h4
                    onClick={handleViewProduct}
                    className="font-semibold text-lg text-gray-900 dark:text-gray-100 mb-2 truncate cursor-pointer hover:text-secondary transition-colors"
                >
                    {product?.name}
                </h4>

                <div className="flex justify-between items-center mt-auto pt-3">
                    <p className="text-secondary font-bold text-lg">
                        KES {utils.toCommas(product?.price || 0)}
                    </p>
                    <button
                        type="button"
                        onClick={handleViewProduct}
                        className="flex items-center gap-2 bg-secondary text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-orange-600 hover:scale-105 transition-all active:scale-95 shadow-sm"
                    >
                        <FaEye className="h-4 w-4" />
                        VIEW
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ProductCard;